import { render, staticRenderFns } from "./asignments.vue?vue&type=template&id=65dde741&"
import script from "./asignments.vue?vue&type=script&lang=js&"
export * from "./asignments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports